<template>
    <div v-loading="!finishGetList">
        <brand-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :categoryData="categoryData"
                            :sortData="filterSet.sort" :paginationData="filterSet.page"></brand-filter-link>
        <brand-list-link :listLayout="listLayout" :brandData="List" :paginationData="filterSet.page"
                          :sortData="filterSet.sort"></brand-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import BrandFilterLink from "@/components/brand/link/BrandFilterLink";
import BrandListLink from "@/components/brand/link/BrandListLink";
import PaginationLink from "@/components/brand/link/PaginationLink";
import brandUtil from "@/components/brand/brandUtil.js";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import DeleteClass from "@/mixins/deleteClass";
import {setExcelConfig, runExcelDownByMethod} from "@/mixins/excelApiDown";
const {filterConfig} = brandUtil;
export default {
    name: "BrandListComponent",
    mixins: [alertMixins, brandUtil, filterMixins, listMixins],
    components: {BrandFilterLink, BrandListLink, PaginationLink},
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
            brandListDelete: this.runDeleteConfirm,
        }
    },
    props: {
        brandType: '',
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
            getFunc: '',

            getCategoryFunc: '',
            isCategory: false,
            categoryData: [],
            categoryApiParamSet: {},
            keyName: '',
            directUrl: '',
            directType: '',

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,

            excelDownloadFunc: 'brand',
            excelDownloadName: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        if (this.isGetFirst) {
            this.getList(true);
        } else {
            this.finishGetList = true;
        }
        EventBus.$on('getExcel',this.excelDown);
    },
    beforeDestroy() {
        
        EventBus.$off('getExcel');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let config = this.returnBrandConfig(this.brandType);
            this.filterLayout = config.filterLayout;
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;
            this.categoryApiParamSet = config.categoryApiParamSet;

            this.keyName = config.keyName
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();
            
            this.excelDownloadName = config.excelDownloadName
            this.excelParamSet = config.excelParamSet

            setExcelConfig(this.excelDownloadFunc, this.excelDownloadName)
            
            if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let defaultParams = Object.assign({}, this.listApiParamSet);
            let listOptions = {
                url: this.$api.$brand[this.getFunc],
                defaultParams: defaultParams,
            }

            this.initList('api', listOptions);

            if (this.isCategory) {
                this.getCategory();
            }
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$member[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDeleteConfirm(key) {
            this.openDeleteConfirm({
                confirm: (value) => {
                    this.runDelete(key, value);
                },
                cancel: () => {
                }
            })
        },

        runDelete(key, value) {
            EventBus.$emit('apiLoading', true);
            this.DeleteClass.runDelete(key, {mb_password: value,})
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.getList();
                }
            })
        },
        excelDown(){
            let  params = this.makeParams(this.filterSet); // 필터 데이터 전부 동기화
            params = Object.assign(params,this.excelParamSet)
            runExcelDownByMethod(params,'get')
        },
        makeParams(filterSet) {
            let returnParams = {}
            let filterList = Object.values(filterSet.filter);
            filterList.forEach(obj => {
                returnParams = this.setFilterParamValue(returnParams, obj);
            });
            if(filterSet.sort.hasOwnProperty('key') && filterSet.sort.hasOwnProperty('order')) {
                if(filterSet.sort.option.hasOwnProperty('keyName')) {
                    returnParams[filterSet.sort.option.keyName] = filterSet.sort.key
                }else{
                    returnParams.orderByType = filterSet.sort.key;
                }

                if(filterSet.sort.option.hasOwnProperty('orderName')) {
                    returnParams[filterSet.sort.option.orderName] = filterSet.sort.order
                }else{
                    returnParams.orderBySort = filterSet.sort.order;
                }


            }
            return returnParams;
        },
        
        setFilterParamValue(params, obj) {
            if(obj.hasOwnProperty('query')) {
                params[obj.key] = obj.query;
            }else if(obj.hasOwnProperty('value')) {
                if(obj.key != 'tab') {
                    if(!obj.option || !obj.option[obj.value]) {
                        params[obj.key] = obj.value;
                    }else{
                        params = Object.assign({}, params, obj.option[obj.value]);
                    }
                }
            }else if(obj.hasOwnProperty('start') && obj.hasOwnProperty('end')) {
                if(!obj.option.start && obj.start != "") {
                    params[obj.key+'sd'] = obj.start;
                }else if(obj.start != ''){
                    params[obj.option.start] = obj.start;
                }
                if(!obj.option.end && obj.end != "") {
                    params[obj.key+'ed'] = obj.end;
                }else if(obj.end != ''){
                    params[obj.option.end] = obj.end;
                }
            }else if(obj.hasOwnProperty('terms')) {
                let keyName = "";
                if(!obj.option.keyName && obj.option.keyName != undefined) {
                    keyName = obj.option.keyName;
                }else{
                    keyName = obj.key;
                }
                params[keyName] = [];
                for (let i = 0; i<obj.terms.length; i++) {
                    if(!obj.option || !obj.option[obj.terms[i]]) {
                        params[keyName].push(obj.terms[i])
                    }else{
                        if(params[keyName].length === 0) {
                            params[keyName] = obj.option[obj.terms[i]].slice();
                        }else{
                            params[keyName] = params[keyName].concat(obj.option[obj.terms[i]]);
                        }

                    }
                }
            }
            return params;
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
